import ExportForm from "../common/ExportForm";

const EXPORT_COLUMNS = [
    { key: "id", label: "Service ID" },
    { key: "code", label: "Code" },
    { key: "name", label: "Name" },
    { key: "category", label: "Category" },
    { key: "price", label: "Price" },
    { key: "costType", label: "Cost Type" },
    { key: "notes", label: "Notes" },
    { key: "voidReason", label: "Void Reason" },
    { key: "validateReason", label: "Validate Reason" },
    { key: "creatorId", label: "Creator" },
    { key: "createdAt", label: "Created At" },
    { key: "updaterId", label: "Updater" },
    { key: "updatedAt", label: "Updated At" },
];

export default function ServiceExportForm() {
    return <ExportForm columns = {EXPORT_COLUMNS} />;
}
